import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'actions';
import InputCheckbox from 'components/atoms/inputs/input-checkbox';

class F1CaptainToConstructorStacking extends Component {
    onChange(isChecked) {
        this.props.dispatch(Action.do('stackCaptainToConstructor', isChecked));
    }

    render() {
        const {lineupsFilter} = this.props;

        return (
            <div>
                <InputCheckbox
                    label="Stack CPT with CNSTR from one team"
                    checked={lineupsFilter.isStackCaptainToConstructorEnabled()}
                    onChange={::this.onChange}
                />
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {filters: lineupsFilter} = state.lineupsData;

    return {
        lineupsFilter,
    };
}

export default connect(mapStatesToProps)(F1CaptainToConstructorStacking);
